<script setup>
import { computed } from 'vue';
import MediaCard from './MediaCard.vue';
import { KANBAN_STATUSES } from '../utils/mediaMeta';

const props = defineProps({
  assets: { type: Array, default: () => [] },
});
defineEmits(['edit']);

const columns = computed(() =>
  KANBAN_STATUSES.map(s => ({
    ...s,
    items: props.assets.filter(a => a.kanbanStatus === s.value),
  }))
);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-6">
    <div
      v-for="col in columns"
      :key="col.value"
      class="flex min-h-[300px] flex-col rounded-xl border-t-2 bg-n-slate-2/60 p-2"
      :class="[col.border]"
    >
      <div class="mb-2 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span
            class="rounded-md px-2 py-0.5 text-[10px] font-bold"
            :class="[col.color]"
          >
            {{ col.label }}
          </span>
          <span class="text-[10px] text-n-slate-11">{{
            col.items.length
          }}</span>
        </div>
      </div>

      <div class="flex-1 space-y-2">
        <MediaCard
          v-for="a in col.items"
          :key="a.id"
          :asset="a"
          @edit="$emit('edit', a)"
        />
        <div
          v-if="!col.items.length"
          class="rounded-md border border-dashed border-n-weak py-8 text-center text-[11px] text-n-slate-11"
        >
          Vazio
        </div>
      </div>
    </div>
  </div>
</template>
